document.addEventListener("shopify:section:load", function(event) {
var swiper = new Swiper(".featured_slider_new", {
        slidesPerView: 1,
        spaceBetween: 20,
  		loop: true,
  		speed: 1000,
  		navigation: {
          nextEl: ".swiper-button-next",
          prevEl: ".swiper-button-prev",
        },
        breakpoints: {
          640: {
            slidesPerView: 1,
          },
          768: {
            slidesPerView: 3,
          },
          1024: {
            slidesPerView: 4,
          }
        }
       
});
var swiper = new Swiper("#most-frequent-bought .mfb", {
        slidesPerView: 2,
        spaceBetween: 20,
  		loop: true,
  		loopedSlides: 15,
  		centeredSlides: false,
  		rewind: false,
  		speed: 1000,
  		navigation: {
          nextEl: ".swiper-button-next",
          prevEl: ".swiper-button-prev",
        },
        breakpoints: {
          640: {
            slidesPerView: 2,
            centeredSlides: true
          },
          768: {
            slidesPerView: 3,
            centeredSlides: true
          },
          1024: {
            slidesPerView: 3,
            centeredSlides: true
          }
        }
       
});  
});
var swiper = new Swiper(".featured_slider_new", {
        slidesPerView: 1,
        spaceBetween: 20,
  		loop: true,
  		speed: 1000,
  		navigation: {
          nextEl: ".swiper-button-next",
          prevEl: ".swiper-button-prev",
        },
        breakpoints: {
          640: {
            slidesPerView: 1,
          },
          768: {
            slidesPerView: 3,
          },
          1024: {
            slidesPerView: 4,
          }
        }   
});


var swiper = new Swiper("#most-frequent-bought .mfb", {
        slidesPerView: 2,
        spaceBetween: 20,
  		loop: true,
  		loopedSlides: 15,
  		centeredSlides: false,
  		rewind: false,
  		speed: 1000,
  		navigation: {
          nextEl: ".swiper-button-next",
          prevEl: ".swiper-button-prev",
        },
        breakpoints: {
          640: {
            slidesPerView: 2,
            centeredSlides: true
          },
          768: {
            slidesPerView: 3,
            centeredSlides: true
          },
          1024: {
            slidesPerView: 3,
            centeredSlides: true
          }
        }   
});


var swiper = new Swiper(".Customer-reviews-block", {
        slidesPerView: 2,
        spaceBetween: 20,
  		loop: false,
  		speed: 1000,
  		navigation: {
          nextEl: ".swiper-button-next",
          prevEl: ".swiper-button-prev",
        },
        breakpoints: {
          320: {
            slidesPerView: 2,
          },
          640: {
            slidesPerView: 2,
          },
          768: {
            slidesPerView: 3,
          },
          1024: {
            slidesPerView: 4,
          },
           1200: {
            slidesPerView: 5,
          
          }
        }
       
});

